import { jsxs as x, jsx as s } from "react/jsx-runtime";
import F from "../field-label/FieldLabel.js";
import { s as e } from "../../../Layout.module-D-Gt5CEC.js";
import n from "classnames";
import c from "../../inline-message/InlineMessage.js";
import { getGridColumnStyle as g } from "../utils.js";
const k = ({
  children: r,
  description: i,
  disabled: m,
  error: t,
  label: a,
  labelComponentSlot: o,
  name: p,
  optionalText: f,
  required: y,
  layoutClassName: h,
  childrenWrapperClassName: u,
  grid: N,
  readonly: d,
  hiddenLabel: v,
  message: l
}) => /* @__PURE__ */ x("div", { className: n(e["form-field-layout"], h), style: g(N), children: [
  !!a && !v && /* @__PURE__ */ s(F, { htmlFor: p, invalid: !!t && !m, optionalText: f, required: y, className: e.label, children: a }),
  !!i && /* @__PURE__ */ s("small", { "data-testid": "description", className: e.description, children: i }),
  /* @__PURE__ */ s(
    "div",
    {
      className: n(e["input-layout"], u, {
        [e.errored]: !!t,
        [e.disabled]: m,
        [e.readonly]: d
      }),
      children: d || r
    }
  ),
  !!a && !!o && /* @__PURE__ */ s("div", { "data-testid": "component-slot", className: e["component-slot"], children: o }),
  !!t && typeof t != "boolean" && /* @__PURE__ */ s(c, { className: e["error-msg"], type: "negative", children: t }),
  !t && !!l && /* @__PURE__ */ s(c, { type: l.type || "neutral", className: e.message, children: l.text })
] });
export {
  k as default
};
